import React, { useEffect, useState } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import { applyUpdate, SW_UPDATE_EVENT } from '../../serviceWorkerRegistration';

/**
 * Aviso de versión nueva de CONEM (la copia local ya la descargó). No recarga sola: quien está
 * capturando en campo decide cuándo; lo capturado ya está en el borrador del dispositivo.
 */
const AppUpdateNotifier = () => {
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const onUpdate = (event) => setRegistration(event.detail);
    window.addEventListener(SW_UPDATE_EVENT, onUpdate);
    return () => window.removeEventListener(SW_UPDATE_EVENT, onUpdate);
  }, []);

  return (
    <Snackbar open={!!registration} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert severity="info" variant="filled" sx={{ alignItems: 'center' }}
        action={(
          <Button color="inherit" size="small" sx={{ fontWeight: 700 }} onClick={() => applyUpdate(registration)}>
            Actualizar
          </Button>
        )}>
        Hay una versión nueva de CONEM.
      </Alert>
    </Snackbar>
  );
};

export default AppUpdateNotifier;
